import React from "react";
import { withTranslation } from "react-i18next";

const BackButton = ({ onClick, t }) => {
  return (
    <button className="back-btn" onClick={onClick}>
      <span className="ico">
        <img
          src={require("assets/images/arrow-back-icon.svg").default}
          alt="arrow"
        />
      </span>
      {t("back")}
    </button>
  );
};

export default withTranslation()(BackButton);

